import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class ServiceabilityAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/serviceability');
  }

  async fetchFacilityServiceability(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const response = await axiosInstance.post(`${this.baseURL}`, payload);
      return this.transformList(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async fetchPlatformServiceability(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const response = await axiosInstance.post(`${this.baseURL}/v2`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }
}

export default ServiceabilityAPIClient;
